import { Headline, Paragraph, Button, Image } from 'Common';
import { TEXT } from 'locales/translations';
import Style from './PreventionPromoCard.style';
import { balloonieFlower } from 'images/landingpages/preventionPromo';
import { linkHandler } from 'utils/linkHandler';

export const PreventionPromoCard = () => {
  const { badge, headline, description, buttonText, altText } = TEXT.preventionPromoCard;
  return (
    <Style>
      <div className="badge">
        <Paragraph className="small-bold">{badge}</Paragraph>
      </div>
      <Image src={balloonieFlower} className="image" alt={altText} />
      <Headline level={4}>{headline}</Headline>
      <Paragraph className="small">{description}</Paragraph>
      <Button to={linkHandler.get('krankenkasse')}>{buttonText}</Button>
    </Style>
  );
};
